function OfficeGalleryController(containerObject){
	/* THIS FIX */
	var _this = this;
	
	/* PRIVATE CONSTANTS */
	
	
	/* PRIVATE VARIABLES */
	var mapContainer;
	var officeMap = null;


	/* PUBLIC PROPERTIES */
	this.container = null;
	this.inited = false;
	
	
	/* PRIVATE FUNCTIONS */
	function _construct(){
		_this.container = containerObject;
		_this.init();
	}
	
	
	function initSliders(){
		var sliderConfig = {
			pagination: {
				el: '.swiper-pagination .inner',
				clickable: true
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			}
		};
		
		$('.gallery-slider', _this.container).each(function (index) {
			var id = '#' + $(this).attr('id');
			var slider = new Swiper(id, sliderConfig);	
		});
	}
	
   
	/* PUBLIC FUNCTIONS */	
	this.init = function(){
		if(!_this.inited){	
			
			// object references
			mapContainer = $('#map-container', _this.container);
			
			// init
			initSliders();

			// office detail pages carry a map in the sidebar; gallery pages do not
			if(mapContainer.length === 1){
				officeMap = new OfficeMap(mapContainer);
			}

			_this.inited = true;
		}
	};
		

	/* INIT CONSTRUCTOR */
	_construct();
}


/* PUBLIC CONSTANTS */
